/**
 * Get Youtube video id from the URL
 * @param {string} url
 */
const getYoutubeVideoId = (url) => {
  if (typeof url === 'string') {
    const VID_REGEX = /(?:youtube(?:-nocookie)?\.com\/(?:[^/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/
    const match = url.match(VID_REGEX)

    if (match) {
      return match[1]
    }

    return null
  }

  return null
}

export default getYoutubeVideoId
